'use strict';
var ShippingOptionsService = /** @class */ (function () {
    /*@ngInject*/
    function ShippingOptionsService($http, $log, $q) {
        this.paymentAddrChanged = false;
        this.existingAddrChosen = true;
        this.newAddrAdded = false;
        this.$http = $http;
        this.$log = $log;
        this.$q = $q;
    }
    /*@ngInject*/
    ShippingOptionsService.prototype.validateShippingAddress = function (address) {
        return this.$q.resolve({
            data: { "response": null, "errors": [], "warnings": [] }
        });
    };
    ShippingOptionsService.prototype.getDefaultAddress = function () {
        var request = this.$http({
            method: 'get',
            url: 'api/account/address/default'
        });
        return (request.then(function (response) {
            return response;
        }, this.handleError));
    };
    return ShippingOptionsService;
}());
export default ShippingOptionsService;
//# sourceMappingURL=shipping-options.service.js.map